import {
    Component,
    ChangeDetectionStrategy,
    OnInit,
    OnDestroy,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalController } from 'flux-core';
import { TeamPortalWindow } from '../team-portal-window/team-portal-window.cmp';
import { UserLocator } from '../../user/user-locator.svc';
import { BehaviorSubject } from 'rxjs';

/**
 * This is the account pause message component.
 *
 * @author sajeeva
 * @since 2023-01-31
 */

@Component({
    selector: 'account-pause-message',
    templateUrl: './account-pause-message.cmp.html',
    styleUrls: [ 'account-pause-message.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountPauseMessage implements OnInit, OnDestroy {

    public isPaused: BehaviorSubject<boolean> = new BehaviorSubject( false );

    public subs: any[] = [];

    /**
     * Constructor
     */
    public constructor(
        protected modalController: ModalController,
        protected userLocator: UserLocator,
        public translate: TranslateService,
    ) {
    }

    public ngOnInit(): void {
        this.subs.push(
            this.userLocator.isUserPaused().subscribe( isPaused => this.isPaused.next( isPaused )),  
        );
    }

    public ngOnDestroy(): void {
        while ( this.subs.length > 0 ) {
            this.subs.pop().unsubscribe();
        };
    }

    /**
     * This will open close page in team portal.
     */
    public showClosePage() {
        this.modalController.show( TeamPortalWindow , { inputs: { page: 'close' }});
    }

}
